import {BaseContainerModel} from '../base-container.model';
import {bl_asv_checklist_line_RowClass} from '../../dbschema';

export class AsvCheckListLineModel extends BaseContainerModel {
    bl_asv_checklist_line: bl_asv_checklist_line_RowClass = new bl_asv_checklist_line_RowClass();
}